
<!-- 
Under15ReplyModal.vue
功能：回報視窗(未滿15足歲保障缺口)
作者：i9400538 陳博承
完成：2021-12-17
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">要保人{{cust.name || ''}}之被保人{{cust.insd_name || ''}}</h3>
        </div>
        <!-- 初始區塊 -->
        <table v-if="type=='1'" class="padding-left-33">
          <tr v-for="(item, index) in inform_sel" :key="index">
            <td>
              <div class="radio radio-inline">
                <input
                  type="radio"
                  name="radio-inform_result"
                  :id="`inform_result-${item.val}`"
                  v-model="inform_result"
                  :value="item.val"
                />
                <label :for="`inform_result-${item.val}`">{{item.text}}</label>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>備註:&nbsp;</label>
              <input
                type="text"
                id="reply_memo-txt"
                v-model="inform_remark"
                class="input-txt"
                placeholder="(限50字)"
                maxlength="50"
              />
            </td>
          </tr>
        </table>
        <br />
        <div v-if="type=='1'" class="text-center">
          <button
            type="button"
            class="btn btn-primary"
            @click="accept"
            :disabled="!inform_result || (inform_result=='5' && !inform_remark.trim())"
          >提交</button>
        </div>
        <!-- 提交 block -->
        <div v-if="type=='2'" class="min-h">
          <h3 class="text-red">此名單為因應保險法第107條修正，公司須盡通知客戶義務，請務必確認回報結果正確性再送出!!</h3>
          <br />
          <br />
          <div class="text-center">
            <button type="button" class="btn-cancel" @click="cancel">取消</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('submit', inform_result, inform_remark)"
            >確定送出</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "Under15ReplyModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    cust: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      type: "1",
      inform_result: "", //回報結果
      inform_sel: [
        { val: "1", text: "已投保含喪葬費用之新契約" },
        { val: "2", text: "已繳回聲明書" },
        { val: "3", text: "不願投保或簽署聲明書" },
        { val: "4", text: "無法聯繫客戶" },
        { val: "5", text: "其他(須備註說明，如已轉籍、要保人已身故...等)" }
      ],
      inform_remark: "" //回報結果備註
    };
  },
  watch: {
    open: function() {
      this.init();
    },
    inform_remark: function() {
      this.inform_remark = this.cleanSpecialChar(this.inform_remark, '~()!');
    }
    
  },
  methods: {
    //初始化
    init() {
      this.type = "1";
      this.inform_result = "";
      this.inform_remark = "";
    },
    //接受
    accept() {
      this.type = "2";
    },
    //取消
    cancel() {
      this.type = "1";
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.min-h {
  padding: 20px 40px;
  min-height: 190px;
  line-height: 1.5;
  position: relative;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
}
.btn-cancel {
  color: #fff;
  border: 1px solid #c66f1c;
  border-radius: 4px;
  box-shadow: none !important;
  border-color: transparent !important;
  background: #c2c4c7 !important;
  display: inline-block;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.input-txt {
  border: 1px solid #c2c4c7;
  border-radius: 4px;
   width: 70%
}
.padding-left-33 {
  padding-left: 33%;
}
</style>